const storage = require('./storage')
const $ = require('jquery')
const pinDiv =  "<li class='d-inline-block pin-container'><div class='pin'>&nbsp;</div><div class='pin-counter'></div></li>"
let initialized = false
var nunjucks = require('../../../../../../../webpack/node_modules/nunjucks');

const getPins = () => {
	return storage.get('pins') || [];
}

const setPinCounter = (pins) => {
	if(!$('.d-inline-block .pin-container').length) {
		//desktop nav
		$('#login-navigation .searchbox').after(pinDiv);
		//mobile nav
		$('.header-top-bar > .container > .search-toggler').before(pinDiv);
	}
	$(".pin-counter").html(pins.length);
	pins.length ? $(".pin-counter").show() : $(".pin-counter").hide()

}

const showMessage = (psrId, add = true) => {
	let type, message, result
	if(add) {
		type = "success";
		message = '"' + psrId + '" '+ window.alertMessageStringAdd;
	} else {
		type = "danger";
		message = '"' + psrId + '" ' + window.alertMessageStringRemove;
	}

	result = nunjucks.render('message.html.twig', {message, type });
	$('body').prepend(result)
}

const setPinClasses = (pins) => {
	$('.pin-it').removeClass('active')
	try {
		let selector = pins.map(psrId => `.pin-it[data-id=${psrId}]`).join(', ')
		$(selector).addClass('active')
	} catch(e) {
		console.error(e)
		storage.set('pins', [])
	}
}

const updatePinClasses = (pins) => {
	pins = pins || storage.get('pins') || []
	setPinClasses(pins)
	setPinCounter(pins)
}

const onPinClick = (event) => {
	const pinEl = $(event.target).closest('.pin-it')
	const psrId = pinEl.data('id')
	toggle(psrId)
}

const toggle = (psrId) => {
	const storagePins = getPins();
	let filteredPins = storagePins.filter(id => id !== psrId)
	if(filteredPins.length === storagePins.length) {
		filteredPins.push(psrId)
		showMessage(psrId, true)
	} else {
		showMessage(psrId, false)
	}
	storage.set('pins', filteredPins)
	updatePinClasses(filteredPins)
	return filteredPins
}

const add = (psrId) => {
	let storagePins = getPins();
	if(!storagePins.includes(psrId)) {
		storagePins.push(psrId)
	}
	storage.set('pins', storagePins)
	updatePinClasses(storagePins)
	showMessage(psrId, true)
	return storagePins
}

const remove = (psrId) => {
	const storagePins = getPins();
	let filteredPins = storagePins.filter(id => id !== psrId)
	storage.set('pins', filteredPins)
	updatePinClasses(filteredPins)
	showMessage(psrId, false)
	return filteredPins
}

const init = () => {
	if(initialized) {
		return
	}
	initialized = true
	updatePinClasses()
	$(document).on('click', '.pin-it', onPinClick)
	$(document).on("click",'.pin-container', () => {window.location.href = window.memoUri})
	nunjucks.configure('/template/dist/views-sortenfinder', {autoescape: true});
}

init()

module.exports = {
	getPins,
	updatePinClasses,
	remove,
	add,
	toggle
}
